import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SplashscreenService } from 'src/app/shared/services/splashscreen.service';

@Injectable()
export class RecentlyAwardedContractsDataService {
  constructor(
    private readonly http: HttpClient,
    private readonly splashscreenService: SplashscreenService
  ) { }

  getContracts(days = 14): Observable<any[]> {
    return this.http.get<any[]>('/api/recentlyawardedcontracts', { params: { days } as any }).pipe(
      tap({
        next: () => this.splashscreenService.notifyFirstWidgetDataLoaded(),
        error: () => this.splashscreenService.notifyFirstWidgetDataLoaded()
      })
    );
  }
}
